/**
 * Always vertical form item layout
 */
export const verticalLayout = {
  labelAlign: 'left',
  labelCol: { xs: 24 },
  wrapperCol: { xs: 24 }
} as const;
